import MeetingTypeListItem from '../MeetingTypesListItem'
import './style.styl'
import ACCESS from 'utils/Access'

import GatedState from './GatedState'


const MeetingTypeList = ({ meetingTypes, defaultMeetingtype, gatedOnClick }) => {
  return (
    <div className="settings-meeting-types-list">
      <MeetingTypeListItem key="default" settings={defaultMeetingtype} isDefault={true} isPublic={true} />
      {meetingTypes
        .sort((mt1, mt2) => mt1.name > mt2.name)
        .map(meetingType => <MeetingTypeListItem key={meetingType} settings={meetingType} />)}
      {!ACCESS.hasPaidGates() && <GatedState gatedOnClick={gatedOnClick}/>}
    </div >
  )
}

export default MeetingTypeList



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/MeetingTypesList/component.js